import { useQuery } from "@tanstack/react-query";
import cx from "classnames";
import { MouseEventHandler } from "react";

import { get } from "@/api";
import { usePlatform } from "@/hooks/usePlatform";
import { useShareReferralReward } from "@/modules/referralRewards/useShareReferralReward/useShareReferralReward";
import { useUser } from "@/modules/user";

import { Text } from "../Text/Text";

type ReferralBannerProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const ReferralBanner = ({ onClick }: ReferralBannerProps) => {
  const { platform } = usePlatform();
  const { user } = useUser();

  const { data: referralRewardForPlatformLocation } = useQuery({
    queryKey: [
      "/incentives/{platformLocationId}/available-referral-reward",
      platform?.id ?? "",
    ],
    queryFn: () =>
      get("/incentives/{platformLocationId}/available-referral-reward", {
        platformLocationId: user?.platformLocation?.id ?? "",
      }).catch(() => null),
  });

  const { data: activeSignupReward } = useQuery({
    queryKey: ["/incentives/{platformLocationId}/active-signup-reward"],
    queryFn: () =>
      get("/incentives/{platformLocationId}/active-signup-reward", {
        platformLocationId: user?.platformLocation?.id ?? "",
      }),
  });

  const { shareReferralReward } = useShareReferralReward({
    platform: platform!,
    rewardTitle: activeSignupReward?.title ?? "a reward",
    user: user!,
  });

  const title = referralRewardForPlatformLocation?.rewardTitle.text;

  const handleClick = () => {
    shareReferralReward();
  };

  if (!title) {
    return null;
  }

  return (
    <button
      className={cx(
        "flex",
        "items-center",
        "justify-between",
        "cursor-pointer",
        "gap-x-6",
        "w-full"
      )}
      type="button"
      onClick={handleClick}
    >
      <div className="mx-8 my-2 flex h-11 w-full items-center justify-between rounded-lg bg-brand-color/10 px-4 py-2">
        <Text className="body1 font-bold text-black" text={title} />
        <div className="rounded-full bg-brand-color px-2 py-0.5 ">
          <Text className="body1 font-bold text-white" text={"Refer"} />
        </div>
      </div>
    </button>
  );
};
